import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormControl, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms'
import {FormlyFieldConfig, FormlyModule} from '@ngx-formly/core'
import {takeUntil, tap} from 'rxjs/operators'
import {BaseComponent, InputFile} from 'compob2b-libs'

@Component({
  selector: 'app-uploader',
  templateUrl: './uploader.component.html',
  styles: `:host {
    margin: 20px 0;
    display: block;
  }`,
  imports: [
    FormlyModule,
    ReactiveFormsModule
  ]
})
export class UploaderComponent extends BaseComponent implements OnInit {
  @Input() accept: string;
  @Input() maxFileSize: number = 25 * 1024 * 1024;
  @Input() multiple = false;
  @Input() hideDescription;
  @Input() allowedMimeType;

  @Output() upload = new EventEmitter<InputFile[]>();

  // uploader: FileUploader = null;

  form = new FormGroup({
    file: new FormControl(null, Validators.required)
  });

  fields: FormlyFieldConfig[];

  ngOnInit() {
    this.fields = [{
      key: 'file',
      type: 'file-upload-input',
      props: {
        fileOptions: {
          maxFileSize: this.maxFileSize,
          accept: this.accept,
          multiple: this.multiple,
          hideDescription: this.hideDescription,
          allowedMimeType: this.allowedMimeType,
        },
      },
      // hooks: {
      //   afterViewInit: (field: FormlyFieldConfigCache) => {
      //     const ref = field?._componentRefs.slice(-1)[0];
      //     if (ref instanceof ComponentRef) {
      //       this.uploader = (ref.instance as FileUploadComponent).uploader;
      //     }
      //   },
      // }
    }];

    this.form.valueChanges
      .pipe(
        takeUntil(this.unsubscribe),
        tap(value => {
          if (value.file && this.form.valid && !this.loading) {
            this.onSubmit()
          }
        })
      )
      .subscribe();
  }

  onSubmit() {
    const files = this.multiple
      ? this.form.value['file'].map(file => {
        return {file: file} as InputFile;
      })
      : [this.form.value];

    this.upload.emit(files);
    this.form.reset();
  }

}
